<template>
  <div class="pullnew">
    <header class="pullnew-header">
      <img src="../../assets/images/activity/pullnew-bg.png" alt="" class="pullnew-header-bg">
      <transition-group tag="div" name="scroll" class="pullnew-header-users">
        <div v-for="(item, index) in userList" :key="item.id" v-if="index === userIndex">
          <img :src="item.image" alt="">
          <span>{{(item.userName.substr(0, 3)).trim()}}**用户在{{item.seconds}}s前已领取课程</span>
        </div>
      </transition-group>
      <div class="pullnew-header-title">
        <h1>从这里，开始你的职场进阶之旅</h1>
        <h3>任选一门好课 · 免费领取</h3>
      </div>
    </header>
    <div class="pullnew-courses" :courseLists="courseLists">
      <PullNewBlock 
        v-for="(item, index) in courseLists" 
        :course="item" 
        :key="index" 
        :isReceive="isReceive"
        @receive="receive"></PullNewBlock>
    </div>
    <div class="bubble"  v-if="bubbleShow">
      <div class="bubble-main">
        <h1>为了保证您领取的课程正常学习</h1>
        <img class="bubble-main-next" src="../../assets/images/activity/next.png" alt="">
        <img :src="qrcode" alt="" class="bubble-main-hideQrcode">
        <div class="bubble-main-qrcode">
          <img class="bubble-main-qrcode" :src="qrcode" alt="">
        </div>
        <p>扫码后自动领取成功</p>
      </div>
      <div class="bubble-close" @click="set({bubbleShow: false})">
        <img src="../../assets/images/live-icon-close.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import keys from 'lodash.keys'
import module from '../../modules/activity/pullnew'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import PullNewBlock from '../../components/Activity/PullNewBlock'

export default {
  data() {
    return {
      userIndex: 0,
      timer: ''
    }
  },
  computed: {
    ...mapState(module.name, keys(module.state)),
    ...mapGetters(module.name, keys(module.getters))
  },
  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapActions(module.name, keys(module.actions))
  },
  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },
  created () {
    this.init()
  },
  mounted() {
    this.timer = setInterval(()=>{
      if (this.userIndex === this.userList.length-1) {
        this.userIndex = 1
      } else {
        this.userIndex += 1
      }
    },2000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.$store.unregisterModule(module.name)
  },
  components: {
    PullNewBlock
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.pullnew {
  background: #f4f6f7;
  padding-bottom: rem(20);
  &-header {
    position: relative;
    padding-top: rem(80);
    text-align: center;
    color: #fff;
    line-height: 1.3;
    background: #f4f6f7;
    font-family:'Microsoft YaHei';
    &-title {
      position: relative;
      z-index: 1;
      opacity: 0;
    }
    h1 {
      font-size: rem(44);
      margin-bottom: rem(15);
      font-weight: bolder;
    }
    h3 {
      font-size: ren(30);
      margin-bottom: rem(75);
    }
    &-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 0;
    }
    &-users {
      position: relative;
      border-radius: rem(100);
      font-size: rem(20);
      width: rem(391);
      height: rem(40);
      margin: auto;
      margin-bottom: rem(21);
      color: #FFF574;
      background: rgba(0,0,0,.3);
      overflow: hidden;
      span {
        line-height: rem(40);
      }
      > div {
        position: absolute;
        left: 50%;
        top: rem(20);
        transform: translate(-50%,-50%);
        width: inherit;
      }
   
      img {
        width: rem(28);
        height: rem(28);
        vertical-align: middle;
        margin-right: rem(5);
        border-radius: 100%;
      }
    }
  }
  &-courses {
    position: relative;
    z-index: 1;
    padding-top: rem(30);
  }
  &-bottom {
    padding: rem(20);
    font-size: rem(22);
    color: #BBBEBF;
    text-align: center;
  }
}
.bubble {
  position: fixed;
  z-index: 99999;
  top:0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .3);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &-close {
    width: rem(60);
    > img {
      width: 100%;
    }
  }
  &-main {
    width: rem(460);
    height: rem(553);
    background: #fff;
    border-radius: rem(14);
    padding-top: rem(57);
    box-sizing: border-box;
    margin-bottom: rem(53);
    position: relative;
    &-next {
      width: rem(15);
   
    }
    &-hideQrcode {
      position: absolute;
      width: rem(553);
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      opacity: 0;
    }
    &-qrcode {
      width: rem(223);
      height: rem(223);
      margin: auto;
      margin-bottom: rem(23);
      > img {
        width: rem(223);
        height: rem(223);
      }
    }
    > p {
      font-size: rem(24);
      color: #4A4A4A;
      margin-top: rem(28);
      margin-bottom: rem(10);
      &:last-child {
        color: #949EA8;
      }
    }
    > h1 {
      width: rem(403);
      height: rem(50);
      line-height: rem(50);
      font-size: rem(24);
      margin: auto;
      border-radius: rem(100);
      background-color: #FFB500;
      background-image: linear-gradient(to right, #FFB500, #F48F00);
      color: #fff;
    }
  }
}
.scroll-enter-active {
  animation: scroll-in .5s;
}
.scroll-leave-active {
  animation: scroll-out .5s;
}
@keyframes scroll-in {
  0% {
    top: rem(40);
  }
  100% {
    top: rem(20);
  }
}
@keyframes scroll-out {
  0% {
    top: rem(0);
  }
  100% {
    top: rem(-20);
  }
}
</style>
